import React, { useEffect, useState } from 'react';
import { Anchor, Box, DataTable, Heading, Pagination } from 'grommet';
import QueryString from 'qs';
import { API, Utils } from '@enrich/shared-lib';

export const JobReporting = () => {
    const stepOptions = [25, 50, 100];
    const [jobs, setJobs] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [pageSize, setPageSize] = useState(stepOptions[0]);

    useEffect(() => {
        if (!page) return;
        let isActive = true;

        (async () => {
            const jobsResponse = await loadJobs({ page, pageSize });

            if (isActive) {
                setPage(jobsResponse.meta.pagination.page);
                setJobs(Utils.deepFlatten(jobsResponse.data));
                setTotalItems(jobsResponse.meta.pagination.total);
            }
        })();

        return () => {
            isActive = false;
        };
    }, [page, pageSize]);

    const handlePageChange = ({ page, startIndex, endIndex }) => {
        const newPageSize = endIndex - startIndex;
        if (pageSize != newPageSize) {
            setPageSize(newPageSize);
        }
        setPage(page);
    };

    const dataColumns = [
        {
            header: 'Name',
            property: 'name',
            render: (job) => {
                return (
                    <Anchor
                        key={job.id}
                        href={`/jobs/${job.id}`}
                        label={job.title}
                    />
                );
            },
            sortable: true,
        },
        {
            header: 'Company',
            property: 'company.name',
            render: (job) => {
                if (!job.company) return null;

                return (
                    <Anchor
                        key={job.company.id}
                        href={`/company/${job.company.id}`}
                        label={job.company.name}
                    />
                );
            },
            sortable: true,
        },
    ];

    return (
        <Box>
            <Heading level="3">Jobs</Heading>
            <DataTable
                primaryKey="id"
                sortable
                border="bottom"
                data={jobs}
                columns={dataColumns}
            />
            <Box align="center" justify="center" pad="small">
                <Pagination
                    numberItems={totalItems}
                    onChange={({ page, startIndex, endIndex }) => {
                        handlePageChange({
                            page,
                            startIndex,
                            endIndex,
                        });
                    }}
                    step={pageSize}
                    stepOptions={stepOptions}
                    summary={true}
                />
            </Box>
        </Box>
    );
};

const loadJobs = async ({ page, pageSize } = {}) => {
    const query = QueryString.stringify({
        filters: {
            isReportingActive: true,
        },
        populate: {
            company: {
                fields: ['id', 'name'],
            },
        },
        pagination: page && pageSize ? { page, pageSize } : undefined,
        sort: ['updatedAt:desc'],
    });

    try {
        const response = await API.get(`/api/jobs?${query}`);
        return response.data;
    } catch (error) {
        console.log(error);
    }

    return [];
};
